<style>
.pop-article ul:not([class^="pop-"]){
    padding-left:10px!important;
}
</style>

<template>
    <p-select :model.sync="model" 
              @on-change="onChange"  
              :multiple="multiple" 
              :filterable="filterable" 
              :filter-method="filterMethod" 
              :placeholder="placeholder" 
              :disabled="disabled"
              :size="size"
              >
         <p-option-group :label="item.name" v-for="(index,item) in content">
            <p-option v-for="(i,info) in item.shops" :value="info.id">{{ info.name }}</p-option>
        </p-option-group>
    </p-select>
</template>
<script>
    import { getJSON } from '../common/utils';
    import { oneOf } from '../../common/utils/assist';

    export default {
        name: 'Select',
        data(){
            return {
                debug:false,
            }
        },
        ready(){
            let d=getJSON('https://shop.7fresh.com/shop/component/rest/index',"GET");
            d.done((data)=>{
                this.content = data.regions;
            });
        },
        props: {
            model: {
                type: [String, Number, Array],
                default () {
                    return [];
                }
            },
            content: {
                type: [Array],
                default () {
                    return [];
                }
            },
            multiple: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            clearable: {
                type: Boolean,
                default: true
            },
            placeholder: {
                type: String,
                default:'请选择门店'
            },
            filterable: {
                type: Boolean,
                default: true
            },
            filterMethod: {
                type: Function
            },
            size: {
                validator (value) {
                    return oneOf(value, ['small', 'large', 'default']);
                },
                default:'default'
            },
        },
        methods: {
            onChange(ids){
                this.$emit("on-change",ids);
            }
        },
       
    };
</script>



// WEBPACK FOOTER //
// xstoresearch.vue?7ea1ebb6